import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants/networking.constants";
import { UseFetchEnabledParams, UseMutationsParams, UseUpdateParams } from "@/shared/interfaces";
import { ICuadreInventario, ICuadreInventarioForm, ICuadreInventarioParams, ICuadrePagingRes } from "@/shared/interfaces/erp/inventario/cuadre-inventario.interface";
import { getUrlParamsFetch } from "@/shared/utils";
import { handleAxiosError } from "@/shared/utils/general";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

const { get, post, put } = erpApi();

// get

export const useFetchGetCuadreInventario = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<ICuadreInventarioParams> = {}) => {
  return useQuery({
    queryKey: ['cuadre', ...Object.values(params ?? {})],
    queryFn: () => getCuadreInventario(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getCuadreInventario = async (
  params?: ICuadreInventarioParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<ICuadrePagingRes>(`${urlBackend}api/v1/cuadre/?${queryParams}`, true);
};

// create

export const useFetchPostCuadreInventario = ({
  navigate,
  returnUrl
}: UseMutationsParams = {

  }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ICuadreInventarioForm) => {
      return postCuadreInventario(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['cuadre']
      });

      navigate && returnUrl && navigate(returnUrl);

    },
    onError: ((error) => {
      handleAxiosError(error);
    }),
    onSettled: () => {

    },
  });
};

export const postCuadreInventario = async (data: ICuadreInventarioForm) => {
  return await post<ICuadreInventario>(`${urlBackend}api/v1/cuadre/`, data, true);
};

// filter by id

export const useFetchGetByIdCuadreInventario = (id: string) => {
  return useQuery({
    queryKey: ['cuadre', id],
    queryFn: async () => {
      return getByIdCuadreInventario(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdCuadreInventario = async (id: string) => {
  const res = await get<ICuadreInventario>(`${urlBackend}api/v1/cuadre/${id}/`, true);
  return res;
};

// update

export const useFetchPutCuadreInventario = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UseUpdateParams<ICuadreInventarioForm>) => {
      return putCuadreInventario(data);
    },
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ['cuadre']
      });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(res.message);
    },
    onError: (error) => {
      handleAxiosError(error);
    },
    onSettled: () => {

    },
  });
};

export const putCuadreInventario = async ({
  id,
  data
}: UseUpdateParams<ICuadreInventarioForm>) => {
  return put<ICuadreInventario>(`${urlBackend}api/v1/cuadre/${id}/`, data, true);
};


export const regenerarPdfCuadreInventario = async (id: string) => {
  return post<{ url_cuadre: string }>(`${urlBackend}api/v1/cuadre/${id}/regenerar-pdf/`, {}, true);
};